import React, { useEffect, useState } from "react";
import { COACHING_CONTENT, buildCoachingSeo } from "../data/coaching";
import Seo from "../components/Seo";
import Footer from "../components/Footer";
import CoachingNav from "../components/coaching/CoachingNav";
import CoachingHero from "../components/coaching/CoachingHero";
import CoachingPaths from "../components/coaching/CoachingPaths";
import CoachingProcess from "../components/coaching/CoachingProcess";
import CoachingTrust from "../components/coaching/CoachingTrust";
import CoachingProjects from "../components/coaching/CoachingProjects";
import CoachingForm from "../components/coaching/CoachingForm";
import CoachingStickyCta from "../components/coaching/CoachingStickyCta";

export default function CoachingPage({ locale }) {
  const t = COACHING_CONTENT[locale];
  const [selectedPath, setSelectedPath] = useState("");

  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [locale]);

  const choosePath = (index) => {
    setSelectedPath(t.form.pathOptions[index] || "");
    document.getElementById("request")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <main
      data-testid={`coaching-page-${locale}`}
      className="bg-[#05070B] text-[#F3F6FA] min-h-screen overflow-x-hidden"
    >
      <Seo {...buildCoachingSeo(t)} />
      <CoachingNav t={t} />
      <CoachingHero t={t} />
      <CoachingPaths t={t} onChoose={choosePath} />
      <CoachingProcess t={t} />
      <CoachingTrust t={t} />
      <CoachingProjects t={t} />
      <CoachingForm
        key={locale}
        t={t}
        locale={locale}
        selectedPath={selectedPath}
        onPathChange={setSelectedPath}
      />
      <Footer />
      <CoachingStickyCta t={t} />
    </main>
  );
}
